import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllLotteryBrandDay = createAsyncThunk(
  'lotteryDay/getAllLotteryBrandDay',
  async ({ skip, limit, search, status }, { rejectWithValue }) => {
    try {
      const params = {};
      if (skip !== undefined) params.skip = skip;
      if (limit !== undefined) params.limit = limit;
      if (search) params.search = search;
      if (status) params.status = status;

      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params,
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/lottery-brand-days/get-all-active-lottery-brand-days`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const newLotteryBrandDays = createAsyncThunk(
  'lotteryDay/newLotteryBrandDays',
  async (lotteryData, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('name', lotteryData.name);
      formData.append('code', lotteryData.code);
      formData.append('lottery_brand_id', lotteryData.lotterybrandId);
      formData.append('sample', lotteryData.sampleImage);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      };

      const response = await axios.post(
        `${PUBLIC_BASE_URL}/lottery-brand-days/create-lottery-brand-day`,
        formData,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || 'Unknown error occurred.');
      }
    }
  }
);

export const editLotteryBrandDays = createAsyncThunk(
  'lotteryDay/editLotteryBrandDays',
  async (lotteryData, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('id', lotteryData.id);

      if (lotteryData.name) {
        formData.append('name', lotteryData.name);
      }
      if (lotteryData.code) {
        formData.append('code', lotteryData.code);
      }
      if (lotteryData.sampleImage) {
        formData.append('sample', lotteryData.sampleImage);
      }
      if (lotteryData.lotterybrandId) {
        formData.append('lottery_brand_id', lotteryData.lotterybrandId);
      }
      if (lotteryData.status !== undefined) {
        formData.append('status', lotteryData.status);
      }

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      };
      const response = await axios.put(
        `${PUBLIC_BASE_URL}/lottery-brand-days/update-lottery-brand-day-info`,
        formData,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || 'Unknown error occurred.');
      }
    }
  }
);

export const getAllLotteryBrandDaysCode = createAsyncThunk(
  'lotteryDay/getAllLotteryBrandCode',
  async ({ id }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/lottery-brand-days/get-active-lottery-brand-days/${id}`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);
